import { Button } from "@mui/material";

import HNSColors from "../../../../../../ui library/HNSColors";

export default function ButttonLink({ label, onClickHandler }) {
  return (
    <Button
      className="pointer py-2 pl-2 text-[0.75rem] capitalize underline"
      sx={{
        color: HNSColors.secondary[500],
        "&:hover": {
          color: HNSColors.secondary[600],
        },
      }}
      onClick={() => onClickHandler()}
    >
      {label}
    </Button>
  );
}
